import { render, staticRenderFns } from "./MyGridKendo.vue?vue&type=template&id=5dde0845&scoped=true&"
import script from "./MyGridKendo.vue?vue&type=script&lang=js&"
export * from "./MyGridKendo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde0845",
  null
  
)

export default component.exports